import React from 'react';
import { motion } from 'framer-motion';
const agents = [{
  name: 'Patty LaBenske',
  title: 'Luxury Desert Real Estate Specialist',
  image: 'https://cdn.magicpatterns.com/uploads/9TMcLSmgsN4t6ESWwxX8hi/patty-headshot_copy.jpg',
  bio: 'With over two decades of experience in the North Scottsdale market, Patty specializes in matching discerning buyers with extraordinary desert properties — pairing deep local expertise with discrete, white-glove service.',
  phone: '928-876-8659',
  phoneHref: 'tel:+19288768659',
  email: 'patty@labensketeam.com'
}, {
  name: 'Simon Patton',
  title: 'Luxury Desert Real Estate Specialist',
  image: 'https://cdn.magicpatterns.com/uploads/eZiTTXmZd2kwYMCVuSBsWD/simon_patton_headshot_square_(1).jpg',
  bio: "Simon brings a sharp eye for architecture and an investor's perspective to every transaction. Clients trust him for clear guidance, sophisticated negotiation, and a relentless commitment to finding the right home — not just any home.",
  phone: 'Contact via team',
  phoneHref: 'tel:+19288768659',
  email: 'patty@labensketeam.com'
}];
export function Agent() {
  return <section className="py-24 md:py-32 bg-cream border-t border-sand/20" data-id="element-28">
      <div className="max-w-6xl mx-auto px-6 md:px-12" data-id="element-29">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16 md:mb-20" data-id="element-30">
          <span className="text-sand uppercase tracking-widest text-sm mb-4 block" data-id="element-31">
            Meet Your Team
          </span>
          <h2 className="text-4xl md:text-5xl font-serif text-stone-deep mb-4" data-id="element-32">
            Patty LaBenske & Simon Patton
          </h2>
          <div className="w-24 h-px bg-sand mx-auto mb-6" data-id="element-33"></div>
          <p className="text-stone-deep/70 max-w-2xl mx-auto" data-id="element-34">
            Two seasoned advisors, one shared standard of service — guiding
            buyers through North Scottsdale's most distinctive properties.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 lg:gap-16" data-id="element-35">
          {agents.map((agent, i) => <motion.div key={agent.name} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: i * 0.15
        }} className="flex flex-col items-center text-center" data-id="element-36">
              <div className="w-40 h-40 md:w-48 md:h-48 rounded-full overflow-hidden border-4 border-cream shadow-[0_0_0_1px_rgba(200,169,110,0.3)] mb-8" data-id="element-37">
                <img src={agent.image} alt={`${agent.name}, ${agent.title}`} className="w-full h-full object-cover" data-id="element-38" />
              </div>

              <h3 className="text-2xl md:text-3xl font-serif text-stone-deep mb-2" data-id="element-39">
                {agent.name}
              </h3>
              <p className="text-sand uppercase tracking-widest text-xs mb-6 font-medium" data-id="element-40">
                {agent.title} · HomeSmart NEXT
              </p>

              <p className="text-stone-deep/80 leading-relaxed mb-8 max-w-md" data-id="element-41">
                {agent.bio}
              </p>
            </motion.div>)}
        </div>

        {/* Shared contact CTAs */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-4" data-id="element-42">
          <a href="tel:+19288768659" className="w-full sm:w-auto px-8 py-4 rounded-full bg-stone-deep text-cream uppercase tracking-widest text-sm hover:bg-brown transition-colors duration-300" data-id="element-43">
            Call 928-876-8659
          </a>
          <a href="mailto:patty@labensketeam.com" className="w-full sm:w-auto px-8 py-4 rounded-full border border-stone-deep text-stone-deep uppercase tracking-widest text-sm hover:bg-stone-deep hover:text-cream transition-colors duration-300" data-id="element-44">
            Send a Message
          </a>
        </motion.div>
      </div>
    </section>;
}